import { combineReducers } from "redux"
import { AppReducer } from "src/App/App.reducer"
import { loginReducer } from "src/pages/Login/Login.reducer"

const rootReducer = combineReducers({
  app: AppReducer,
  login: loginReducer,
})

export default rootReducer
